import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import {useFormInput} from '../../utils/utilities';
import {useDispatch, useSelector} from 'react-redux';
import CustomButton from '../CustomButton';
import {addEntrance, editEntrance} from '../../actions';
import {fieldError, isFieldIvalid} from '../../utils/errorHandler';

const EntranceModal = ({edit}) => {
  const dispatch = useDispatch();
  const {modalProps} = useSelector(s => s.modal);
  const {entrancesLoading, entrancesError} = useSelector(s => s.entrances);
  const name = useFormInput(edit ? modalProps.entrance.name || '' : '');

  const onSubmit = e => {
    e.preventDefault();
    if (edit) {
      dispatch(
        editEntrance(name.value, modalProps.buildingID, modalProps.entrance.id),
      );
    } else {
      dispatch(addEntrance(name.value, modalProps.buildingID));
    }
  };

  const errorMessage = () => {
    if (typeof entrancesError === 'string' && entrancesError !== '') {
      return entrancesError;
    } else if (isFieldIvalid(entrancesError, 'name')) {
      return fieldError(entrancesError, 'name');
    }
    return '';
  };

  return (
    <>
      <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
        {edit ? 'Edit entrance' : 'Add a new entrance'}
      </Typography>
      <form onSubmit={onSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          mt="2rem"
          gap="1rem"
          sx={{
            width: {xs: 'calc(100vw - 4rem)', sm: '30rem'},
          }}>
          <TextField
            {...name}
            error={!!entrancesError}
            helperText={errorMessage()}
            required
            label="Entrance name"
          />
          <CustomButton type="submit" loading={entrancesLoading}>
            Submit
          </CustomButton>
        </Box>
      </form>
    </>
  );
};

export default EntranceModal;
